<template>
  <div id="southernEngineering">
    <div class="flex row top-bar_wrapper">
      <div
        class="progress-name progress-name-active pointer"
      >南方工程简报
      </div>
    </div>
    <div
      class="flex flex1 justify-between item-center button-title__box"
    >
      <div class="flex justify-start">
        <GreenButton
          class="button__default"
          text="填报"
          @click="createChange"
        ></GreenButton>
      </div>
    </div>
    <el-table
      :data="dataList"
      :header-cell-style="{background: 'rgba(0,0,0,0.02)',borderTop:'1px solid rgba(0,0,0,0.1)'}"
      :loading="loading"
      class="table-box"
      height="calc(100% - 165px)"
    >
      <el-table-column
        label="标题"
        prop="Title"
      ></el-table-column>
      <el-table-column
        label="附件"
      >
        <template #default="scope">
          <div
            v-for="(urlItem,urlIndex) in scope.row['LinkFiles']"
            :key="urlIndex"
            class="flex column"
          >
            <div
              class="file-download pointer"
              @click="downloadFileChange(urlItem)"
            >{{ urlItem.Name }}
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="上传部门"
        prop="Group"
        width="200"
      ></el-table-column>
      <el-table-column
        label="上传人"
        prop="UserName"
        width="120"
      ></el-table-column>
      <el-table-column
        label="上传时间"
        prop="CreationDate"
        width="120"
      >
        <template #default="scope">
          <span>{{ scope.row['CreationDate'] | timeDateFilter }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="160"
      >
        <template #default="scope">
          <el-link
            type="primary"
            @click="editInfo(scope.row)"
          >
            编辑
          </el-link>
          <el-link
            style="margin-left: 1em;"
            type="primary"
            @click="deleteInfo(scope.row)"
          >
            删除
          </el-link>
        </template>
      </el-table-column>
    </el-table>
    <div
      class="table-box__pagination flex flex1 justify-end items-center"
    >
      <el-pagination
        :current-page.sync="pageIndex"
        :page-size.sync="pageSize"
        :total="allTotal"
        layout="total, prev, pager, next"
        @current-change="onPageIndexChange"
      ></el-pagination>
    </div>
    <SouthernEngineeringDialog
      :id="currentID"
      :is-edit="isCreateEdit"
      :visible="createDialogVisible"
      @closeDialog="onImportDialogClose"
      @refresh="onRefreshDialogClose"
    ></SouthernEngineeringDialog>
    <el-image-viewer
      v-if="isShowImage"
      :on-close="
          () => {
            isShowImage = false
          }
        "
      :url-list="srcList"
    ></el-image-viewer>
  </div>
</template>
<script>
import GreenButton from '@/components/buttons/GreenButton'
import SouthernEngineeringDialog from '@/components/dialog/SouthernEngineeringDialog'

let _this = void 0
//import { mapState, mapMutations } from 'vuex'

export default {
  name: 'southernEngineering',
  mixins: [],
  components: { GreenButton, SouthernEngineeringDialog },
  props: {},
  data() {
    return {
      pageIndex: 1,
      pageSize: 11,
      allTotal: 0,
      loading: false,
      dataList: [],
      createDialogVisible: false,
      isCreateEdit: false,
      currentID: -1,
      isShowImage: false,
      srcList: []
    }
  },
  computed: {
    //...mapState('', {}),
  },
  watch: {},
  filters: {
    timeDateFilter(date) {
      return typeof date === 'string' ? date.split('T')[0] : ''
    },
  },
  directives: {},
  created() {
    _this = this
  },
  mounted() {
    this.getDataInfo()
  },
  destroy() {
  },
  methods: {
    //...mapMutations('', []),
    /**
     * 获取 南方工程简报 数据
     * */
    async getDataInfo() {
      this.loading = true
      const { success, data } = await this.$http({
        url: this.$api.getPageQueryProjectNews,
        params: {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize
        }
      })
      if (success) {
        const { rows, total } = data
        if (data.hasOwnProperty('rows')) {
          this.dataList = [...rows]
          if (data.hasOwnProperty('total')) {
            this.allTotal = total
          }
        }
      }
      this.loading = false
    },
    /**
     * 切换分页
     * */
    onPageIndexChange(pageIndex) {
      this.pageIndex = pageIndex
      this.getDataInfo()
    },
    /**
     * 填报 选择
     * */
    createChange() {
      this.createDialogVisible = true
    },
    /**
     * 填报 关闭dialog回调
     * */
    onImportDialogClose() {
      this.isCreateEdit = false
      this.createDialogVisible = false
    },
    /**
     * 填报 刷新dialog回调
     * */
    onRefreshDialogClose() {
      this.isCreateEdit = false
      this.createDialogVisible = false
      this.pageIndex = 1
      this.getDataInfo()
    },
    /**
     * 编辑信息
     * */
    editInfo(item) {
      const { ID } = item
      this.currentID = ID
      this.isCreateEdit = true
      this.createDialogVisible = true
    },
    /**
     * 删除信息
     * */
    deleteInfo(item) {
      const { ID } = item
      this.$confirm('是否确认删除', '删除南方工程简报', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            instance.confirmButtonText = '删除中...'
            setTimeout(async () => {
              await this.deleteChange(ID)
              done()
              setTimeout(() => {
                instance.confirmButtonLoading = false
              }, 300)
            }, 300)
          }
          else {
            done()
          }
        }
      })
    },
    /**
     * 确认删除
     * */
    async deleteChange(ID) {
      const { success } = await this.$http({
        url: this.$api.goDeleteProjectNews,
        params: {
          id: ID
        }
      })
      if (success) {
        this.$message.success('删除成功')
        this.pageIndex = 1
        await this.getDataInfo()
      }
    },
    /**
     * 下载文件
     * */
    downloadFileChange(item) {
      const { RemotePath, Name } = item
      if (RemotePath !== '') {
        this.srcList = []
        this.isShowImage = true
        const newUrl = `${WEB_CONFIG.BASE_URL}${RemotePath}`
        this.srcList.push(newUrl)
      }
      else {
        this.$message.error('下载失败')
      }
    }
  }
}
</script>
<style
  lang="scss"
  scoped
>
#southernEngineering {
  height: 100%;
}

::v-deep .el-link.el-link--primary {
  color: #005BAC;
}
</style>
<style lang="scss"></style>
